import React, { useEffect, useState } from "react";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { Box, Button, TextField, Typography } from "@mui/material";
import { updateLocalStorage } from "../../../../AppDrawerNav";
import {
  childNodeNavText,
  problemStatementNode,
  problemStatementNodeInput,
  topNavNode,
} from "../GeneralNodeStyles";
import { inputStyles } from "../../../../../../Constants/inputStyles";
import theme, { createLLMTypography } from "../../../../../../Constants/theme";
import { primaryButtonStyles } from "../../../../../../Constants/buttonStyles";
import AdvancedOptionsDialog from "./AdvancedOptionsDialog";

function ProblemStatementNode({ data }) {
  const [displayOptions, setDisplayOption] = useState(false);
  const { botData, setBotData } = data;
  const [localData, setLocalData] = useState(botData);
  const [showGenerateInfo, setShowGenerateInfo] = useState(false);

  // Sync state with data.botData whenever it changes
  useEffect(() => {
    setLocalData(data.botData); // Update data_ when data.botData updates
  }, [data.botData]);

  const onProblemStatementChange = (event) => {
    setShowGenerateInfo(true);
    const newValue = event.target.value;
    localStorage.setItem("problem_statement", JSON.stringify(newValue));
    setLocalData((prevData) => ({
      ...prevData,
      problem_statement: newValue,
    }));
    setBotData((prevData) => ({
      ...prevData,
      problem_statement: newValue,
    }));
  };

  const handleOpenSideBar = (infotype, event) => {
    event.stopPropagation();
    updateLocalStorage("open_sidebar", "true");
    updateLocalStorage("type", infotype);
  };

  return (
    <Box sx={problemStatementNode} data-tour="step-two">
      <Box sx={{ ...topNavNode }}>
        <Typography sx={childNodeNavText}>Problem Statement</Typography>
        <div>
          <InfoOutlined
            onClick={(event) => handleOpenSideBar("problem_statement", event)}
          />
        </div>
      </Box>

      <Box sx={problemStatementNodeInput}>
        <TextField
          fullWidth
          multiline
          rows={6}
          placeholder={"I want a helpful assistant."}
          value={localData?.problem_statement}
          onChange={onProblemStatementChange}
          onBlur={() => setShowGenerateInfo(false)}
          onClick={() => setShowGenerateInfo(true)}
          variant="outlined"
          sx={{
            ...inputStyles.textField,
            "& .MuiOutlinedInput-root": {
              backgroundColor: createLLMTypography.colors.inputsBackground,
              borderRadius: "10px",
            },
          }}
        />
        {showGenerateInfo && (
          <Typography sx={{ color: theme.state.warning.primary }}>
            Changing the problem statement requires prompt regeneration in the
            generation module
          </Typography>
        )}
        <Button
          sx={{
            ...primaryButtonStyles,
            borderRadius: theme.borderRadius.sm,
            fontSize: theme.typography.fontSize.md,
            fontWeight: theme.typography.fontWeight.bold,
            alignSelf: "start",
          }}
          onClick={() => setDisplayOption((prev) => !prev)}
          data-tour="step-four"
        >
          Advanced Options
        </Button>
      </Box>

      {displayOptions && (
        <AdvancedOptionsDialog
          displayOptions={displayOptions}
          setDisplayOption={setDisplayOption}
          localData={localData}
          setLocalData={setLocalData}
          setBotData={setBotData}
        />
      )}
    </Box>
  );
}

export default ProblemStatementNode;
